import React from 'react';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import {Provider} from 'react-redux';
import {PersistGate} from 'redux-persist/integration/react';
// eslint-disable-next-line no-unused-vars
import i18n from './i18n/i18n';
import configureStore from "./redux/store";
import Chatbot from "./components/chatbot/Chatbot";
import {createRoot} from 'react-dom/client';
import {BrowserRouter} from "react-router-dom";
import "primereact/resources/themes/lara-light-cyan/theme.css";
import 'primereact/resources/themes/saga-blue/theme.css';
import 'primereact/resources/primereact.min.css';
// import 'primeicons/primeicons.css';
import 'primeflex/primeflex.css';

const {store, persistor} = configureStore();
const container = document.getElementById('root');
const root = createRoot(container);

root.render(
    <Provider store={store}>
        <PersistGate loading={null} persistor={persistor}>
            <BrowserRouter>
                <App/>
                <Chatbot/>
            </BrowserRouter>
        </PersistGate>
    </Provider>
);

reportWebVitals();